import React from "react";
import { Drawer, Box } from "@mui/material";
import { CloseIcon } from "../../../styles/img/svg/CloseIcon";
import { SideBackIcon } from "../../../styles/img/svg/SideBackIcon";

export const UiRightSideModal = ({
  openSideModal,
  handleBack,
  handleClose,
  children,
}) => {
  return (
    <Drawer
      className="df-drawer-modal"
      anchor="right"
      open={openSideModal}
      onClose={handleClose}
    >
      {handleBack && (
        <div onClick={handleBack} className="df-drawer-modal__back">
          <SideBackIcon />
        </div>
      )}
      {handleClose && (
        <div
          data-testid="close-icon"
          onClick={handleClose}
          className="df-drawer-modal__close"
        >
          <CloseIcon />
        </div>
      )}
      <Box className="df-side-drawer" data-testid="side-modal">{children}</Box>
    </Drawer>
  );
};
